const constants = {
  prefProperties: [
    'sfid',
    'email',
    'firstName',
    'lastName',
    'emailOptIn',
    'customerType',
    'onceAWeek',
    'postalCode',
    'smsOptIn',
  ],
  messageValuesKeys: {
    keys: 'WISH_LIST_DEFAULT_MESSAGE,PASSWORD_RESET,PASSWORD_RESET_INSTRUCTIONS,INVALID_SPEC_INSTRUCTIONS,CHECKOUT_REGISTER,CART_EMPTY,INVALID_QUANTITY,EMPTY_QUANTITY,MISSING_FIRST_NAME,MISSING_LAST_NAME,MISSING_SUBJECT,MISSING_EMAIL,INVALID_EMAIL,MISSING_MESSAGE,MISSING_ORGANIZATION_NAME,TOOL_TIP_TAX_EXEMPT,TOOL_TIP_TAX_EXEMPT_B2I,DISCONTINUED,GREENGUARD,SELECTION_PROMPT,SHOPPING_CART_DEFAULT_MESSAGE,SOLD_OUT,INACTIVE,CREDIT_CARD_EXPIRES_WITHIN_MONTH,SESSION_EXPIRED_SIGNED_IN,SESSION_EXPIRED_GUEST,WISH_LIST_LINK_NOT_VALID,CATALOG_REQUEST_THANK_YOU,MISSING_USERAGREEMENT,PROMO_SETUP_ERROR,CHECKOUT_PAYPAL_BILLING,LOGIN_PASSWORD_INCORRECT,REQUEST_QUOTE_INVALID,REQUEST_QUOTE_INVALID_CART,MYSTERY_PROMO_PLAYED,EMPTY_COLOR,QUICK_ORDER_NO_GIFTCARD,ROPIS_CHANGE_STORE,ROPIS_MISSING_SKU_AVAILABILITY,ROPIS_ADJUSTED_QUANTITY,ROPIS_CHECKOUT_DELIVERY_PICKUP,ROPIS_NO_ELIGIBLE_ITEMS,ROPIS_API_DOWN,CREDIT_CARD_EXPIRED,CHECKOUT_GC_API_DOWN,ROPIS_NOT_ELIGIBLE,ROPIS_UNAVAILABLE,ROPIS_NOT_ELIGIBLE_AT_THE_STORE,ROPIS_STORES_CLOSE_UNEXPECTED,SHIPPING_RESTRICTION,CONTIGUOUS_SHIPPING_RESTRICTION,SHIPPING_RESTRICTIONS_APPLY,SHIP_ITEM_IN_STOCK,ADDRESS_SUGGESTION_PROMPT,SHIP_ADDRESS_PO_BOX,IN_STORE_SPECIAL_PDP_PICKUP,LOGISTICS_NO_DATE,LOGISTICS_OLD_DATE,TAX_HELPER_TEXT,JOB_NO_LONGER_AVAILABLE,MAIL_GIFT_CARD_TERMS,IN_STORE_SPECIAL_PDP_SHIP,MAIL_GIFT_CARD_DESCRIPTION,EMAIL_GIFT_CARD_TERMS,EMAIL_GIFT_CARD_DESCRIPTION,ROPIS_INVALID_MOBILE,ROPIS_DUE_IN_STORE,STORE_ONLY_ITEM,CART_DISCONTINUED_INACTIVE,STORE_ONLY_OUT_OF_STOCK,ROPIS_CART_NO_LONGER_AVAILABLE,STORE_ONLY_NOT_AVAILABLE,ORDER_MGMT_HISTORY,INSTORE_PICKUP,CURBSIDE_PICKUP,CURB_INSTORE_PICKUP,STORE_PICKUP_TAX_EXEMPT,STORE_PICKUP_INFO,STORE_ONLY_NOT_ELIGIBLE,STORE_PICKUP_SELECTION_PROMPT,STORE_ONLY_SALE_PRICE,CHECKOUT_SHIPPING_STREET_PO_BOX_ADDRESS,SOLD_OUT_ALL_STORES,REVIT_ACCESS_ERROR,DOWNLOAD_ERROR,SOLD_OUT_SHIP,BACKORDER_INSTORE_AVAILABLE,REGISTRY_DEFAULT_MESSAGE,REGISTRY_DEFAULT_SOCIAL_MESSAGE,REGISTRY_SUBJECT,REGISTRY_DELETE,PERSONALIZATION,CART_SOLD_OUT,SESSION_ABOUT_TO_EXPIRE,OPTIONAL_NUMBER_MESSAGE,SHIP_ADDRESS_FORMAT,REGISTRY_DELETE_CONFIRM,REGISTRY_NO_ITEMS,REGISTRY_EMPTY,REGISTRY_LINK_NOT_VALID,AUTO_DETECT_SERVICES_OFF,ADDED_AS_STORE_PICKUP,INVALID_REGISTRY_TO_EMAIL,LIMITED_STOCK_ALL_STORES,ORDER_NUMBER_INFO,CREATE_ACCOUNT_TEXT,PERSONALIZED_STORE_PICKUP,EMPTY_QUOTES_SEARCH,EMPTY_ITEM,MISSING_NAME,MISSING_PHONE,MISSING_ZIP,MISSING_EVENT_TYPE,B2C_WEBSITE_COOKIE_NOTICE,EMPTY_AMOUNT_PHYSICAL_GC,EMPTY_AMOUNT_ELECTRONIC_GC,EMPTY_CUSTOM_AMOUNT_GC,EMPTY_CUSTOM_AMOUNT_EGC,GWP_EGC_ADDED_TO_CART,PRE_SELL_AVAILABILITY,PRE_SELL_CONTACT_INFO,REGISTRY_GROUP_GIFT_INFO,REGISTRY_GROUP_GIFT_GUEST_INFO,REGISTRY_GROUP_GIFT_DISABLED_REDEMPTION,DISABLED_SEARCH,LOYALTY_MEMBER_PDP,LOYALTY_POINTS_TOTAL,QUICKORDER_FORM_EMPTY,LOYALTY_MESSAGE,LOYALTY_MEMBER_SHIP,LOYALTY_MEMBER_BOPIS,LOYALTY_MEMBER_MIXED,LOYALTY_PROFILE_TERMS_CONDITIONS,LOYALTY_PROFILE_TERMS_CONDITIONS_MODAL,LOYALTY_PROFILE_PRIVACY_POLICY_MODAL,LOYALTY_EARN_POINTS_REGISTRY,CONTACT_US_EDIT_ORDER,REVIT_REQUEST_ACCESS_CONFIRMATION,LOYALTY_MEMBER_SHIP_OTY,LOYALTY_MEMBER_BOPIS_OTY,LOYALTY_MEMBER_MIXED_OTY,SELECT_CANCEL_ITEMS,NAME_FORMAT,SMS_OPT_IN_DISCLAIMER,CLASSROOM_LIST_DEFAULT_MESSAGE,CLASSROOM_LIST_DEFAULT_SOCIAL_MESSAGE,CLASSROOM_LIST_SUBJECT,BUDGETS_NO_RESULTS,EMPTY_SEARCH,SHOPPING_LIST_DEFAULT_MESSAGE,SHOPPING_LIST_SUBJECT,COMMUNICATION_PREFERENCES_REDIRECT,MAIL_PREFERENCES_REDIRECT,SHOPPING_LIST_DEFAULT_SOCIAL_MESSAGE,MISSING_SEARCH_INPUT,MISSING_STATE,GUEST_EDIT_ORDER_MESSAGE,GSA_USER_REDIRECT_TITLE,GSA_USER_REDIRECT_MESSAGE,EMPTY_CONTRACT_GPO_NAME,PASSWORD_SECURITY,MISSING_REASON_FOR_RETURN',
  },
  MOBILE_MAX_RECS: '24',
  spriteimage: {
    backgroundImage: 'url(/assets/images/LakeshoreSprites_v16.svg)',
  },

  stayConnectedProperties: {
    lightbox: 'lightbox',
  },

  LLConstants: {
    STORE_PICKUP_ONLY: 'Store Pickup Only',
    STORE_SPECIAL_LABEL: 'Lower Price in Store',
    STAR_PXL_WIDTH: 20,
  },
  links: {
    privacyPolicy: '/about/privacy-policy',
  },
  PDP: 'PDP',
  productDetailsPageParams: ['p', 's', 'P', 'S'],
  name: {
    narrowByLabel: 'Narrow by',
  },
  shareProduct: {
    shareheading: 'Share',
    shareViaEmail: 'Share Via Email',
    shareViaPinterest: 'Share Via Pinterest',
    shareViaFacebook: 'Share Via Facebook',
  },
  shareProductEmail: {
    modalHeading: 'Email an Item',
    filedInfo: 'Fields in <strong>bold</strong> are required.',
    fromHeading: 'From',
    toHeading: 'To',
    errorNameText: 'Please enter a name.',
    errorEmailText: 'Please enter an email address.',
    errorEmailInvalidText: 'Please enter a valid email address.',
    labelTextName: 'Name',
    labelTextEmail: 'Email',
    labelTextMsg: 'Message',
    info: 'LakeshoreLearning.com will only use these email addresses to send this message.',
    textareaText:
      'Take a look at this super-cool item I found at LakeshoreLearning.com!',
  },
  messageTextValue: {
    ROPIS_NO_ELIGIBLE_ITEMS:
      'Sorry! The items are out of stock at this store or not eligible for store pickup.',
    STORE_PICKUP_INFO:
      'Shopping is now faster and easier than ever! Simply select &quot;Store Pickup&quot; to buy eligible items online…and they&apos;ll soon be waiting for you in your local Lakeshore store. For complete details, visit our &lt;a href=&quot;/help/in-store-pickup/&quot;&gt;Store Pickup&lt;/a&gt; page.',
    GSA_USER_REDIRECT_MESSAGE:
      'To simplify your shopping journey, you’re being redirected to our main Lakeshore website. All cart items and contract pricing will be retained.',
    GSA_USER_REDIRECT_TITLE: 'Contract Account Log-In Redirect',
  },
  outOfStockOnline: 'We’re sorry, this item is currently sold out online.',
  soldOutMsg:
    'This item is currently sold out. Please try a different selection.',
  ROPIS_STORES_CLOSE_UNEXPECTED:
    'We’re sorry, but store pickup at this location may be delayed. Don’t worry, though—you can still place your order! We’ll notify you as soon as it’s ready for pickup.',
  videoViewer: 'VideoViewer',
  skipRefreshOnLogin: ['/shopping-cart/'],
  browserStorageKeys: {
    sessionStorageTimestamp: 'sessionTimestamp',
    localStorageTimestamp: 'localTimestamp',
  },
};

export default constants;

const StorePickupType: { [key: string]: string } = {
  curbSide: 'CURBSIDE_PICKUP',
  instore: 'INSTORE_PICKUP',
  curbAndInstore: 'CURB_INSTORE_PICKUP',
  ropis: 'ROPIS_UNAVAILABLE',
};

const storeUserMessage: { [key: string]: string } = {
  CURBSIDE_PICKUP: 'Curbside Pickup Only',
  ROPIS_UNAVAILABLE: 'Store pickup is currently unavailable at this location.',
  INSTORE_PICKUP: 'In-Store Pickup Only',
  CURB_INSTORE_PICKUP: 'In-Store & Curbside Pickup Available',
};

const GiftCardType = {
  'E-Gift': 'eGiftCardHeader',
  Gift: 'giftCardHeader',
};

const COOKIE_EXPIRY_TIME = 365;

const SortBy: { [key: string]: string } = {
  'Best Sellers': 'best',
  'Price - Low': 'price-desc',
  'Price - High': 'price-asc',
  'Top Rated': 'top-rated',
  "What's New": 'new',
};

const RecsPerPage: { [key: string]: number } = {
  '24 Per Page': 24,
  '96 Per Page': 96,
  '48 Per Page': 48,
};

const RECORD_PER_ROW = 4;
const SEARCH_SUGGESTIONS_COUNT = 5;
const SEARCH_CATEGORIES_COUNT = 4;

const SchemaMarkupConstants = {
  productAvailability: 'InStock',
  contact: {
    phone: '+1-800-428-4414',
    type: 'customer service',
    option: 'TollFree',
  },
  links: {
    base: 'https://www.lakeshorelearning.com',
    home: 'https://www.lakeshorelearning.com/',
    imageBaseUrl: 'https://img.lakeshorelearning.com/is/image/OCProduction/',
    logo: 'https://img.lakeshorelearning.com/is/image/OCProduction/ll_logo',
    schema: 'http://schema.org',
  },
  name: {
    home: 'Lakeshore&reg; Learning Materials',
  },
  type: {
    breadcrumbList: 'BreadcrumbList',
    contactPoint: 'ContactPoint',
    itemList: 'ItemList',
    listItem: 'ListItem',
    offer: 'Offer',
    organization: 'Organization',
    person: 'Person',
    product: 'Product',
    rating: 'AggregateRating',
    review: 'Review',
    thing: 'Thing',
  },
};

const LocationRefinementMap: { [index: string]: string } = {
  inStoreSku: 'Ship Item',
  shipOrderSku: 'Store Pickup',
};

const ProductDetailContent: any = {
  shippingRestriction: 'Shipping restrictions apply.',
  listTypeMsg: {
    private: 'Only you can see this list.',
    public: 'People can search for your public lists.',
  },
  shippingDescription:
    '<div class="warning-content"><p>Express shipping is not available for this item. Your entire order will arrive by Standard Shipping. Also, please note that free shipping and promotional offers do not apply to this item when shipped.</p><p>We’re here to help! If you have any questions, don’t hesitate to email <a href="/help/contact-us/">Customer Service</a> or call (800) 428-4414, Mon.–Fri., 5 am–6 pm, PT.</p><p>For complete details, see <a href="/help/shipping-policies/">our shipping policies</a>.</p></div>',
};
export {
  StorePickupType,
  SortBy,
  RecsPerPage,
  SchemaMarkupConstants,
  LocationRefinementMap,
  GiftCardType,
  COOKIE_EXPIRY_TIME,
  RECORD_PER_ROW,
  SEARCH_SUGGESTIONS_COUNT,
  SEARCH_CATEGORIES_COUNT,
  storeUserMessage,
  ProductDetailContent,
};

export const pdpBadgesModal: { [key: string]: string } = {
  lifetimeWarranty: `<p>
      Lakeshore believes in the quality of our products, and we stand behind them. Our no-nonsense warranty
      guarantees that the items we create are meticulously designed
      and carefully crafted to withstand the test of time. If any product breaks within the warranty period, we
      will repair or replace it&mdash;at no charge!
    </p>
    <p>
      Our warranty covers any structural defects that are found under normal, everyday use. Structural defects do
      not include cosmetic damage caused by regular wear
      & tear (such as the gradual fading of fabrics over time) or damage caused by factors outside of normal use,
      such as acts of nature, modification, or unreasonable or abusive use.
    </p>`,
  bifma: `<p>
    Lakeshore is excited to offer a variety of furniture that has earned BIFMA verification! BIFMA (Business + Institutional Furniture Manufacturers Association) sponsors the development of furniture safety and performance standards to help customers make confident buying decisions. BIFMA-compliant furniture has been validated at third party–accredited labs against rigorous performance standards so customers can be assured that it’s safe and of the highest quality. 
    </p>
    <p>
      <a href="/products/featured-assortments/bifma/" data-bs-toggle="modal">View Lakeshore products that are BIFMA compliant.</a>
    </p>
    <p>
      To learn more, visit <a href="https://www.bifma.org/" target="_blank">BIFMA</a>. You can also request more information by contacting Customer Service at (800) 428-4414, Mon.–Fri., 5 am–6 pm, PT. 
    </p>`,
  fullyAssembled: `<p>
      We put it together&mdash;so you don't have to! Our fully assembled furniture is designed to save you valuable time
      and energy,
      arriving ready to use right out of the box. In some cases, you may need to attach casters or door
      handles&mdash;but that's it!
    </p>`,
  '50yrWarranty': `<p>
      Lakeshore believes in the quality of our products, and we stand behind them. Our no-nonsense warranty guarantees that the items we create are meticulously designed and carefully crafted to withstand the test of time. If any product breaks within the warranty period, we will repair or replace it—at no charge!
    </p>
    <p>
    Our warranty covers any structural defects that are found under normal, everyday use. Structural defects do not include cosmetic damage caused by regular wear & tear (such as the gradual fading of fabrics over time) or damage caused by factors outside of normal use, such as acts of nature, modification, or unreasonable or abusive use.
    </p>`,
  '10yrWarranty': `<p>
      Lakeshore believes in the quality of our products, and we stand behind them. Our no-nonsense warranty guarantees that the items we create are meticulously designed and carefully crafted to withstand the test of time. If any product breaks within the warranty period, we will repair or replace it—at no charge!
    </p>
    <p>
    Our warranty covers any structural defects that are found under normal, everyday use. Structural defects do not include cosmetic damage caused by regular wear & tear (such as the gradual fading of fabrics over time) or damage caused by factors outside of normal use, such as acts of nature, modification, or unreasonable or abusive use.
    </p>`,
  '5yrWarranty': `<p>Lakeshore believes in the quality of our products, and we stand behind them. Our no-nonsense warranty
						guarantees that the items we create are meticulously designed
						and carefully crafted to withstand the test of time. If any product breaks within the warranty period, we
						will repair or replace it—at no charge!</p>
          <p>
						Our warranty covers any structural defects that are found under normal, everyday use. Structural defects do
						not include cosmetic damage caused by regular wear
						&amp; tear (such as the gradual fading of fabrics over time) or damage caused by factors outside of normal use,
						such as acts of nature, modification, or unreasonable or abusive use.
					</p>`,
};

export const pdpPromoMessageModal = {
  title: 'Current Promotions Details',
};

export const URLS = {
  HOME_PAGE_URLS: ['', '/', '/homepage', '/preview'],
  PRODUCT_PAGE_URLS: ['/products'],
  PDP_PAGE_URLS: ['/p/', '/P/', '/s/', '/S/'],
  SHOPPING_CART_PAGE_URL: '/shopping-cart',
  CHECKOUT_PAGE_URL: '/checkout-page',
  FURNITURE_TAB_URL_PREFIX: '/furniture',
};

export const searchTabsConstant = {
  CHARACTER_LIMIT: 500,
  WORKSHEET: 'worksheet',
  LESSONPLAN: 'lessonPlan',
  CRAFTIDEA: 'craftIdea',
  CRAFT: 'Craft',
  LESSON: 'Lesson Plan',
  CRAFT_URL: '/resources/free-resources/crafts/',
  FREE_RESOURCES_URL: '/resources/free-resources/learning-activities/',
  VIDEO_URL: '/products',
  VIDEO: '/videos/',
};
export const googlePay = {
  IN_STORE_PICKUP_ONLY: 'instorePickUpOnly',
  EMAIL_AND_IN_STORE_PICKUP: 'emailAndInstorePickup',
  EMAIL_ONLY: 'emailOnly',
  GOOGLE_PAY: 'GooglePay',
  PAYMENT_DATA_REQ_BODY: {
    shippingFirstName: '',
    shippingLastName: '',
    shippingAddress1: '',
    shippingAddress2: '',
    shippingCity: '',
    shippingCountry: '',
    shippingPostalCode: '',
    shippingPhoneNumber: '',
    shippingState: '',
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    postalCode: '',
    state: '',
    cardNetwork: '',
    cardDetails: '',
    cardDisplayName: '',
    phoneNumber: '',
    useRegistryAddress: false,
    orderShipType: '',
    token: '',
    tokenType: '',
    description: '',
    email: '',
    _dynSessConf: '',
  },
};

export const applePay = {
  APPLE_PAY: 'applePay',
};

export const PageLoadTypes = {
  Search_Box_Product_Click: 'typeaheadProductClick',
  Carousel_Product_Click: 'carousel',
  Search_Box_Search_Term_Click: 'internalSearchTermTypeAhead',
  Search_Box_Category_Click: 'typeaheadCategoryClick',
  Search_Box_Recent_Product_Click: 'recentProductClick',
  Search_Box_Recent_Search_Click: 'recentSearchClick',
};
export const localStorageRetainKeys = ['recentSearches', 'recentlyViewed'];

export const ButtonNames = {
  SEARCH_INPUT_REMOVE: 'remove_search_input',
};

export const ShippingAddressModalData = {
  clearListTitle: 'Clear the List Shipping Address',
  registryTitle: 'Registry Shipping Address',
  clearListContent: `Your order contains an item from someone’s list. Would you like to ship it to the address they provided?`,
  registryContent: `Your order contains a registry item. Would you like to ship it to
            the address provided by the registrant?`,
};

export const RewardsTier = {
  VIP_GOLD: 'VIP Gold',
  VIP: 'VIP',
};

export const LoginStatus = {
  GUEST: 'guest',
  RECOGNIZED: 'recognized',
  LOGGED_IN: 'loggedIn',
};

export const itemsGroupsOrder = [
  {
    key: 'FIRST_NON_ROPIS_ITEM',
    property: 'shipItem',
    subTotalFor: 'webOnly',
    subTotalLabel: 'Shipping Subtotal',
    title: 'Ship Order',
  },
  {
    key: 'FIRST_ROPIS_ITEM',
    property: 'storePickup',
    subTotalFor: 'instorePickUpOnly',
    subTotalLabel: 'Store Pickup Subtotal',
    title: 'Store Pickup',
  },
  {
    key: 'FIRST_DIGITAL_ITEM',
    property: 'emailDelivery',
    subTotalFor: 'emailDelivery',
    subTotalLabel: 'Email Delivery Subtotal',
    title: 'Email Delivery',
  },
  {
    key: 'UNAVAILABLE',
    property: 'unavailable',
    subTotalFor: '',
    subTotalLabel: '',
    title: 'Unavailable',
  },
];

export const REGEX = {
  FURNITURE_TAB_URL: /^\/furniture\//,
};
